import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import FNOLHOWizard from './FNOLHOWizard';
import FNOLHOTypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
import FNOLHOIncidentDetailsPage from './pages/FNOLHOIncidentDetails/FNOLHOIncidentDetails';
import FNOLFireDamagePage from './pages/FireDamage/FireDamagePage';
import FNOLWaterDamagePage from './pages/WaterDamage/WaterDamagePage';
import FNOLCriminalDamagePage from './pages/CriminalDamage/CriminalDamagePage';
import LossLocationComponent from './pages/FNOLHOIncidentDetails/LossLocation/LossLocationComponent';
import SelectAddressComponent from './pages/FNOLHOIncidentDetails/LossLocation/SelectAddressComponent';

setComponentMapOverrides(
    {
        FNOLHOWizard: { component: 'FNOLHOWizard' },
        FNOLHOTypeOfIncidentPage: { component: 'FNOLHOTypeOfIncidentPage' },
        FNOLHOIncidentDetailsPage: { component: 'FNOLHOIncidentDetailsPage'},
        FNOLFireDamagePage: { component: 'FNOLFireDamagePage' },
        FNOLWaterDamagePage: { component: 'FNOLWaterDamagePage' },
        FNOLCriminalDamagePage: { component: 'FNOLCriminalDamagePage' },
        LossLocationComponent: { component: 'LossLocationComponent' },
        SelectAddressComponent: { component: 'SelectAddressComponent' }
    },
    {
        FNOLHOWizard,
        FNOLHOTypeOfIncidentPage,
        FNOLHOIncidentDetailsPage,
        FNOLFireDamagePage,
        FNOLWaterDamagePage,
        FNOLCriminalDamagePage,
        LossLocationComponent,
        SelectAddressComponent
    }
);

export {
    FNOLHOWizard as default,
    FNOLHOTypeOfIncidentPage,
    FNOLHOIncidentDetailsPage,
    FNOLFireDamagePage,
    FNOLWaterDamagePage,
    FNOLCriminalDamagePage,
    LossLocationComponent,
    SelectAddressComponent
};
